import Content from '@nrdy-marketing-engine/components/src/content';
import { useInterpolation } from '@nrdy-marketing-engine/interpolation';
import clsx from 'clsx';
import { FormInputPanelData, PanelData, PanelStateProps } from '../../@types/panel-data';
import BackButton from '../back-button';
import ContinueButton from '../continue-button';
import FormInput from '../form-input';
import InputValidation from '../form-input/input-validation';
import * as styles from './shared-styles-panel.css';
import { verifyObjectOnInput } from './verify-input-value';
/** Returns true if the given panel is a FormInputPanel. */
export function isFormInputPanel(step: PanelData): step is FormInputPanelData {
  return step._modelApiKey === 'panel_form_input';
}

/**
 * A panel that renders one or more form input controls, such as text fields,
 * email, checkboxes, etc.
 */
function FormInputPanel({
  onInput,
  inputFields,
  headline,
  content,
  continueButton,
  backButton,
  onBack,
  onNext,
  formData,
  validationErrors,
  loading,
}: FormInputPanelData & PanelStateProps) {
  return (
    <div className="mb-auto">
      <Content
        className={clsx(
          'prose-base prose-strong:text-xl sm:prose-strong:text-2xl sm:prose-lg',
          styles.heading
        )}
        heading={useInterpolation(headline)}
        headingLevel={1}
      >
        {useInterpolation(content)}
      </Content>
      <div className="my-6 flex flex-col gap-4">
        {inputFields.map((field, index) => (
          <FormInput
            {...field}
            autoFocus={index === 0}
            key={field.name || field.type}
            loading={loading}
            onInput={(value) => verifyObjectOnInput(value, field, onInput)}
            onNext={onNext}
            validationErrors={validationErrors[field.name || field.type]}
            value={formData[field.name || field.type]}
          />
        ))}
      </div>
      <InputValidation validationErrors={validationErrors.custom} />
      {continueButton && (
        <ContinueButton loading={loading} onClick={onNext} text={continueButton.text} />
      )}
      {backButton && <BackButton onClick={onBack} text={backButton.text} />}
    </div>
  );
}

export default FormInputPanel;
